import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { NuevaAxiosURL } from "../../../utils/utils";
import MobileInput from "../../Mobile/Inputs/MobileInput";
import MobileButton from "../../Mobile/Buttons/MobileButton";
import ElevvaLogo from "../../Mobile/Elements/ElevvaLogo";
import "./Login.css";

const LoginSkeleton = () => {
    return (
        <div className="d-flex flex-column align-items-center w-100 gap-3">
            <div className="mobile-skeleton mobile-skeleton-title"></div>

            <div className="d-flex flex-column align-items-center w-100">
                <div className="mobile-skeleton mobile-skeleton-text"></div>
                <div className="mobile-skeleton mobile-skeleton-text"></div>
                <div className="mobile-skeleton mobile-skeleton-text-short"></div>
            </div>
            <div className="w-100 d-flex flex-column gap-3">
                <div className="mobile-skeleton mobile-skeleton-input"></div>
                <div className="mobile-skeleton mobile-skeleton-input"></div>
                <div className="mobile-skeleton mobile-skeleton-button"></div>
            </div>
        </div>
    );
};

const Login = ({ elevvaT = (key) => key }) => {
    const navigate = useNavigate();
    const [displayError, setDisplayError] = useState(false);
    const [displayLoading, setDisplayLoading] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        const usuario = event.target.mail.value.trim();
        const password = event.target.pass.value.trim();
        const servicio = "users/auth/login/";

        setDisplayLoading(true);

        const formData = new FormData();
        formData.append("email", usuario);
        formData.append("password", password);

        axios({
            method: "post",
            url: `${NuevaAxiosURL}${servicio}`,
            params: { t: new Date().getTime() },
            data: formData,
        })
            .then((res) => {
                const data = res.data;
                if (data) {
                    localStorage.my_code = data.access;
                    localStorage.refresh = data.refresh;

                    const instanceLogin = axios.create({
                        baseURL: NuevaAxiosURL,
                        params: { t: new Date().getTime() },
                        headers: { Authorization: "Bearer " + data.access },
                    });

                    // 1. Fetch Company Data
                    instanceLogin.get(`memberships/corp/company`)
                        .then((res) => res.data)
                        .then((companyData) => {
                            localStorage.setItem("mob_api_key", companyData.mob_api_key);
                            localStorage.setItem("mob_integration", companyData.mob_integration);
                            localStorage.setItem("mob_currency", companyData.currency);

                            // 2. Fetch User Data
                            return instanceLogin.get("users/");
                        })
                        .then((response) => {
                            let data_user = response.data;
                            const type = "Usuario";

                            localStorage.type = type;
                            localStorage.first_name = data_user.first_name;
                            localStorage.last_name = data_user.last_name;
                            localStorage.email = data_user.email;
                            localStorage.id = data_user.id;
                            localStorage.elevva_role = data_user.role;
                            localStorage.privacy_policy_accepted = data_user.privacy_policy_accepted;
                            localStorage.terms_and_conditions_accepted = data_user.terms_and_conditions_accepted;

                            if (data_user.customer) {
                                localStorage.profile_pic = data_user.customer.profile_pic;
                            }
                            if (data_user.membership) {
                                localStorage.membership = data_user.membership.membership.id;
                            }

                            // 3. User Type Validation & Redirect
                            if (data_user.type == 20) { // Trainer
                                if (data_user.trainer?.is_enabled) {
                                    navigate("/dashboard");
                                } else {
                                    setDisplayLoading(false);
                                    setDisplayError(true);
                                    return;
                                }
                            } else if (data_user.type == 10) { // User
                                if (data_user.is_corporate) {
                                    if (data_user.role == 10 || data_user.role == 20) {
                                        navigate("/dashboard/home");
                                    } else {
                                        navigate("/dashboard/mob/booking");
                                    }
                                } else {
                                    setDisplayLoading(false);
                                    setDisplayError(true);
                                }
                            } else {
                                localStorage.clear();
                                setDisplayLoading(false);
                                setDisplayError(true);
                            }
                        })
                        .catch((err) => {
                            console.error("Error fetching user details:", err);
                            setDisplayLoading(false);
                            setDisplayError(true);
                        });
                }
            })
            .catch((err) => {
                console.error(err);
                setDisplayError(true);
                setTimeout(() => setDisplayError(false), 3000);
                setDisplayLoading(false);
            });
    };

    return (
        <div> {/* Form container for desktop max-width */}
            <div className="d-flex flex-column align-items-center w-100 gap-3">
                <h1 className="mobile-login-title mb-0 animate-fade-in-up">Bienvenido</h1>

                <p className="mobile-login-description mb-0 animate-fade-in-up delay-1">
                    Gestiona tu gimnasio y eleva la experiencia de tus atletas.
                </p>

                {displayError && (
                    <p className="alert alert-danger w-100 py-2 text-center mb-1 small animate-fade-in-up">
                        Correo y/o contraseña incorrectas.
                    </p>
                )}

                <form className="w-100 d-flex flex-column gap-3 animate-fade-in-up delay-2" onSubmit={handleSubmit}>
                    <MobileInput
                        type="email"
                        name="mail"
                        label="Correo electrónico"
                        placeholder="ejemplo@correo.com"
                        required
                    />

                    <MobileInput
                        type="password"
                        name="pass"
                        label="Contraseña"
                        placeholder="Tu contraseña"
                        required
                    />

                    <div className="d-flex flex-column align-items-center gap-3 mt-2">
                        <span className="mobile-login-link-main cursor-pointer" onClick={() => !displayLoading && navigate("/auth/signup")}>
                            Registra tu cuenta aquí
                        </span>

                        <span className="mobile-login-link-secondary" onClick={() => !displayLoading && navigate("/auth/forgot-password")}>
                            ¿Olvidaste tu contraseña?
                        </span>

                        <MobileButton
                            text="Iniciar sesión"
                            type="submit"
                            className="mt-3"
                            loading={displayLoading}
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default React.memo(Login);
